"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Item = _interopRequireDefault(require("./Item"));

var _this = void 0;

/**
 * ChargeInfo.Notice
 * @description 计费UI组件-提示信息
 */
var Notice = function Notice(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var marginSize = _ref.marginSize,
      styleType = _ref.styleType,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    marginSize: marginSize,
    controllerCol: {
      span: 12
    },
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Notice, {
    style: {
      textAlign: "left"
    },
    closable: false,
    styleType: styleType
  }, children));
}.bind(void 0);

Notice.propTypes = {
  /** 间距尺寸 */
  marginSize: _propTypes["default"].oneOf(["xs", "sm", "md", "lg", "xlg"]),

  /** 样式类型 */
  styleType: _propTypes["default"].oneOf(["default", "success", "warning", "error", "disabled"]),

  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  style: _propTypes["default"].object,

  /** @ignore */
  children: _propTypes["default"].node
};
Notice.defaultProps = {
  marginSize: "xs",
  styleType: "default"
};
var _default = Notice;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Notice.js
// module id = 2091
// module chunks = 6 7 17 18